export type AverageCheckDayValues = Record<string, number>

export type AverageCheckSchool = {
  school_id: number
  school_title: string
  revenue_by_day: AverageCheckDayValues
  sales_count_by_day: AverageCheckDayValues
}

export type AverageCheckTotals = {
  revenue_by_day: AverageCheckDayValues
  sales_count_by_day: AverageCheckDayValues
}

export type AverageCheckDto = {
  from: string
  to: string
  days: Array<string>
  schools: Array<AverageCheckSchool>
  totals: AverageCheckTotals
}

export const daysFormat = 'DD.MM.YYYY' as const
export const datesFromToFormat = 'YYYY-MM-DD' as const
